
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Navigate } from "react-router-dom";
import baseUrl from "../Api";


export async function listcategory() {
  try {
    return await axios
      .get(`${baseUrl}/categorylist`)
      .then((response) => {
        const res = response.data;
        // Only expose active categories (active == 1) to all consumers
        if (res && Array.isArray(res.data)) {
          res.data = res.data.filter((x) => x.active == 1);
        }
        return res;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function listtype() {
  try {
    return await axios
      .get(`${baseUrl}/typelist`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function listcategorycount(data) {
  try {
    return await axios
      .post(`${baseUrl}/categorycountlist`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


export async function listhomeslider(data) {
  try {
    return await axios
      .post(`${baseUrl}/homesliderlist`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function listteammembers(data) {
  try {
    return await axios
      .post(`${baseUrl}/teammemberlist`, data)
      .then((response) => {
        const res = response.data;
        // Only expose active members (active == 1) to the public site
        if (res && Array.isArray(res.data)) {
          res.data = res.data.filter((x) => x.active == 1);
        }
        return res;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}



export async function listproduct(data) {
  try {
    return await axios
      .post(`${baseUrl}/productlist`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function viewproducts(id) {
  try {
    return await axios
      .get(`${baseUrl}/viewproduct/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function addcontact(data) {
  try {
    return await axios
      .post(`${baseUrl}/contact`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
function catcherror(error) {
  console.log(error.response)
  if (error.response.status === 401 ) {
    localStorage.clear();
    <Navigate to={"/"} />;
  } else if (error.response.status === 422) {
    Swal.fire({
      title: "There are few errors occured while inserting/updating the data to the database.",
      showCancelButton: false,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    });
  }  else if (error.response.status === 0) {
    toast.error(error.message);
  } else if (error.response.status === 500) {
    toast.error(error.response.statusText);
  } else if (
    error.response.status !== 200 &&
    error.response.data.status === false &&
    error.response.data.code !== 200
  ) {
    toast.error(error.response.data.message);
  } else if (error.request) {
    toast.error(error.request.statusText);
  } else {
    toast.error(error.message);
  }
}
